import { FC, useEffect, useState } from 'react';
import { CareMapDrawerPage } from '../../components/CareMapDrawerPage';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { IonButton } from '@ionic/react';
import { HistoryViewModel } from '../../support/HistoryViewModel';
import { CareMapDrawerState } from '../../caremap/CareMapDrawerState';
import { MixPanelEventEmitter as MixpanelService } from '../../metrics/MixPanelEventEmitter';
import { PatientFormState } from '../../avatar/PatientFormState';
import { ActivePatientEditForm } from './ActivePatientEditForm';

export const CaremapDrawerPatientEdit: FC = () => {
    const drawerState = useInstance(CareMapDrawerState);
    const careMapStateInstance = useInstance(CareMapState);
    const history = useInstance(HistoryViewModel);
    const patientForm = useInstance(PatientFormState);
    const tracking = useInstance(MixpanelService);

    const [initialDiagnosesPrivacy] = useState<boolean>(careMapStateInstance.getActiveCaremap()?.patient.diagnosesIsPublic!);

    useSubscription(() => patientForm);
    useSubscription(() => careMapStateInstance);

    const patient = patientForm.state.patient;


    useEffect(() => {
        drawerState.setIsMaskingFocusedCareMap(true);

        return () => {
            drawerState.setIsMaskingFocusedCareMap(false);
        };
    }, [drawerState]);


    if (!careMapStateInstance.state) {
        return null;
    }

    // TODO: consider moving this into PatientFormState
    const isValid = Boolean(patient?.firstName?.trim());

    const onSave = () => {
        if (!patient){
            throw new Error(`attempted to save but there is no patient`);
        }
        careMapStateInstance.updatePatient(patient);
        tracking.track('Care Recipient Edited', () => ({
            '# of Diagnoses': (patient.diagnoses || []).length,
            '# of Allergies': (patient.allergies || []).length,
            'Diagnoses Privacy': patient.diagnosesIsPublic ? 'public' : 'private',
            'Diagnoses Privacy Toggled': patient.diagnosesIsPublic !== initialDiagnosesPrivacy,
            '# of Contact Methods': careMapStateInstance.cleanupContactMethods(patient.contactMethods).length
        }));

        history.back();
    };

    const onCancel = () => {
        history.back();
    };

    const buttons = <>
        <IonButton data-type="save-button" disabled={!isValid} onClick={onSave}>Save</IonButton>
        <IonButton data-type="cancel-button" fill="outline" onClick={onCancel}>Cancel</IonButton>
    </>;

    return (
        <>
            <CareMapDrawerPage
                title="Edit Care Recipient"
                hasBack={true}
                buttons={buttons}
                data-type="member-edit"
                data-member-id="patient"
            >
                <ActivePatientEditForm />

            </CareMapDrawerPage>
        </>
    );
};
